module.exports = __webpack_public_path__ + "static/media/flat_bed_trailer.d6cd9c83.svg";